import { Col, Container, Row } from "react-bootstrap";
import LeftSection from "../Components/LeftSection/LeftSection";
import RigntCards from "../Components/RightFourCards/RightFourCards";
import { Helmet } from "react-helmet";
import NavBar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>
          Manzil : Child Skill Development & Occupational Training Centre in
          Sharjah{" "}
        </title>
        <meta
          name="description"
          content="Manzil is the best special Needs Centre in Sharjah, providing social support for persons or students with disabilities, Child skill development, & occupational training."
        />
        <meta
          name="keywords"
          content="Manzil center, Special Family Support, special need school, Autism Center in Sharjah, NGO in Sharjah, Sharjah, UAE, special EMPLOYMENT PROGRAM in sharjah"
        />
        <link rel="canonical" href="https://www.manzil.ae" />
        <meta
          property="og:title"
          content="Manzil : Child Skill Development & Occupational Training Centre in Sharjah"
        />
        <meta
          property="og:description"
          content="Manzil is the best special Needs Centre in Sharjah, providing social support for persons or students with disabilities, Child skill development, & occupational training."
        />
        <meta property="og:url" content="https://www.manzil.ae" />
        <meta
          property="og:image"
          content="https://www.manzil.ae/static/media/manzil-banner.9f1104f852c3b95ac8c3.png"
        />
        <meta
          name="twitter:title"
          content="Manzil : Child Skill Development & Occupational Training Centre in Sharjah"
        />
        <meta
          name="twitter:description"
          content="Manzil is the best special Needs Centre in Sharjah, providing social support for persons or students with disabilities, Child skill development, & occupational training."
        />
        <meta
          name="twitter:image"
          content="https://www.manzil.ae/static/media/manzil-banner.9f1104f852c3b95ac8c3.png"
        />
      </Helmet>
      <NavBar />
      <Container fluid>
        <Row>
          <Col lg={6} className="p-0">
            <LeftSection />
          </Col>
          <Col lg={6} className="p-0">
            <RigntCards />
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
